<template>
  <div class="baniere pt-6 md:pb-24 pb-10">
    <div class="md:flex md:mt-20">
      <div class="md:w-1/2 pt-4">
        <img
          src="../../../assets/images/jpg/sante.jpg"
          alt=""
          data-aos="fade-right"
          data-aos-duration="2000"
        >
      </div>

      <div class="md:w-1/2 md:pl-20 md:pt-16 pt-6">
        <div
          class="titre1"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Créez des expériences personnalisées pour les patients
        </div>
        <divider
          :height="diviserHeight"
          :color="diviserColor"
          class="mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        />
        <div
          class="title3 mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Personnalisez les expériences de soins de santé en donnant aux patients le contrôle sur leurs données médicales sécurisées et en leur permettant d’accéder à des informations dans le but de favoriser les soins autonomes et la gestion du bien-être.
        </div>

        <div
          class="titre1 md:mt-12 mt-6"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Enrichissez l’expérience des équipes soignantes
        </div>
        <divider
          :height="diviserHeight"
          :color="diviserColor"
          class="mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        />
        <div
          class="title3 mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Améliorez la collaboration avec les équipes soignantes pour rationaliser la coordination des soins, communiquer avec les patients en toute sécurité et améliorer les résultats en matière de santé grâce à des incitations fondées sur la valeur.
        </div>

        <div
          class="titre1 md:mt-12 mt-6"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Diminuez le coût des soins
        </div>
        <divider
          :height="diviserHeight"
          :color="diviserColor"
          class="mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        />
        <div
          class="title3 mt-4"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Grâce aux données sécurisées, accélérez les diagnostics, diminuez le temps de traitement et améliorez l’efficacité des équipes soignantes ainsi que les résultats pour les patients.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#EAEEFA',
      diviserHeight: '3px'
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .bloc1{
    width: 32%;
  }
  .bloc2{
    width: 68%;
    font-weight: bold;
    font-size: 24px;
    line-height: 160%;
  }

  .titre{
    font-weight: 800;
    font-size: 40px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: $black
  }
  .titre1{
    font-weight: 600;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }
  .title3{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }

  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 28px;
    }

    .titre1{
      font-size: 20px;
    }
    img{
      width: 380px;
      height: 258px;
    }
    .title3{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 50px;
    }
    .titre3{
      font-size: 20px;
    }
    .titre1{
      font-size: 30px;
    }
  }
</style>
